import { $themeBreakpoints } from '@themeConfig'
import http from '@axios'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    portfolios: [],
    portfolioUpdated: false,
    portfolioLoading: false,
    portfolioError: false,
    updatedPortfolios: [],
    virtualPortfolioRunsUsage: 0, // daily
  },
  getters: {
    usersNumberOfPortfolios: state => state.portfolios.length,
    virtualPortfolioRunsUsage: state => state.virtualPortfolioRunsUsage,
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_PORTFOLIOS(state, val) {
      state.portfolios = val
    },
    REMOVE_PORTFOLIO_BY_ID(state, id) {
      const index = state.portfolios.findIndex(p => parseInt(p.portfolioId, 10) === id)

      if (index !== -1) {
        state.portfolios.splice(index, 1)
      }
    },
    SET_PORTFOLIO_UPDATED(state, val) {
      state.portfolioUpdated = val
    },
    ADD_UPDATED_PORTFOLIOS(state, portfolioIds) {
      // Convert the IDs to integers
      const portfolioIdsInt = portfolioIds.map(pId => parseInt(pId, 10))

      // Add it to the store
      state.updatedPortfolios.push(...portfolioIdsInt)
    },
    ADD_UPDATED_PORTFOLIO(state, portfolioId) {
      // Check and remove if there's an already existing duplicate
      state.updatedPortfolios = state.updatedPortfolios.filter(p => p !== portfolioId)

      // Add it to the store
      state.updatedPortfolios.push(parseInt(portfolioId, 10))
    },
    REMOVE_UPDATED_PORTFOLIO(state, portfolioId) {
      state.updatedPortfolios = state.updatedPortfolios.filter(p => p !== parseInt(portfolioId, 10))
    },
    UPDATE_VIRTUAL_PORTFOLIO_RUNS_USAGE(state, todaysUsage) {
      state.virtualPortfolioRunsUsage = todaysUsage
    },
  },
  actions: {
    updatePortfolios({ state, dispatch }) {
      state.portfolioLoading = true
      http.get('lifecycle/public/portfolio.cfc?method=getPortfolios')
        .then(response => {
          state.portfolios = response.data.portfolios
        })
        .catch(error => {
          if (error.response && error.response.status === 403) { return }
          setTimeout(() => {
            dispatch('updatePortfolios')
          }, 3000)
        })
        .then(() => {
          state.portfolioLoading = false
        })
    },
    updateRunsCounts({ commit }) {
      http.get('lifecycle/public/report.cfc?method=getTodaysVirtualPortfolioRunUsage')
        .then(response => {
          commit('UPDATE_VIRTUAL_PORTFOLIO_RUNS_USAGE', response.data.virtual)
        })
    },
  },
}
